export default "__VITE_ASSET__b29ec368__"